<style scoped>
</style>

<script>
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
import 'datatables.net-select-bs4/css/select.bootstrap4.min.css';

import 'datatables.net';
import "datatables.net-bs4";
import 'datatables.net-buttons/js/dataTables.buttons';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import 'datatables.net-select-bs4';

import 'datatables.net-keytable-bs4';

export default {
	components: {},
	props: {
		data : {
			type: Array,
      required: false,
			default: () => ([]),
		},
		option : {
			type: Object,
      required: false,
      default: () => ({}),
		},
		tableAddClasses : {
			type : String,
      required: false,
      default: '',
		},
		tableRemoveClasses : {
			type : String,
      required: false,
      default: '',
		},
		keyOfSelection : {
			type : String,
      required: false,
      default: '_selected',
		},
		tableStyles : {
			type : String,
      required: false,
      default: '',
		},
		clickSelctor : {
			type : String,
			required : false,
			default: 'td, a, button'
		},
	},
	data() {
		return {
			id : `datatable_${Math.floor(new Date().getTime() / 1000 * Math.random())}`,
			table : null,
			tableClasses : {
				table : true,
				'table-sm' : true,
				'w-100' : true,
				nowrap : true,
				'table-striped' : true,
				selectable : false,
			}
		}
	},
	computed : {
		getTableClass : function() {
			const orgTableClasses = { ...this.tableClasses };
			if(this.tableAddClasses) {
				this.tableAddClasses.split(' ').forEach(v => {
					orgTableClasses[v] = true;
				});
			}

			if(this.tableRemoveClasses) {
				this.tableRemoveClasses.split(' ').forEach(v => {
					orgTableClasses[v] = false;
				});
			}

			if(this.option && this.option.select) {
				orgTableClasses.selectable = true;
			}

			return orgTableClasses;
		},
		dummy : function() {
			return !!this.data;
		},
	},
	mounted() {
		const newOption = {
			searching : true,
			paging : true,
			ordering : false,
			scrollX: true,
			scrollY: false,
			scrollCollapse : false,
			buttons : (this.option && this.option.buttons) || [],
			language: {
				paginate: {
					previous: "<i class='mdi mdi-chevron-left'>",
					next: "<i class='mdi mdi-chevron-right'>",
				},
				buttons: {
					selectAll: "전체선택",
					selectNone: "선택해제",
				}
			},
			drawCallback: function () {
				window.$(".dataTables_paginate > .pagination").addClass("pagination-rounded");
			},
			data : this.data,
			...this.option
		};

		newOption.dom = `
			${newOption.searching || newOption.buttons.length ? "<'row'<'col-sm-12 col-md-6'B><'col-sm-12 col-md-6'f>>" : ''}
			<'row'<'col-sm-12'tr>>
			${newOption.paging ? "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>" : ''}
		`;

		this.table = window.$(`#${this.id}`).DataTable(newOption);
		this.table.on('click', this.clickSelctor, this.clickHandling);

		this.$emit('onInit', this.table);
	},
	updated() {
		this.table.clear();
		if(this.data) {
			this.table.rows.add(this.data).rows(( idx, data, node ) => {
				return data[this.keyOfSelection] === true;
			}).select().draw();
		}
	},
	methods : {
		clickHandling : function(e) {
			let node = e.target;
			while(node.nodeName !== 'TD') {
				node = node.parentNode;
			}
			
			const tableCell = this.table.cell(node);
			const index = tableCell.index();
			
			this.$emit('clickHandler', index, tableCell.row(index.row).data(), e);
		}
	},

}
</script>

<template>
	<table :id="id" :class="getTableClass" :style="tableStyles" :dummy="dummy">
	<thead>
		<slot name="thead"></slot>
	</thead>
	<tfoot>
		<slot name="tfoot"></slot>
	</tfoot>
	</table>
</template>
